import React from "react";
import { useMediaQuery } from "react-responsive";
import Mobile from "./Mobile";
import Web from "./Web";

function MainRoutes() {
	console.log("MainRoutes rendering");
	const isTabletOrMobile = useMediaQuery({ query: "(max-width: 599px)" });
	console.log("isTabletOrMobile:", isTabletOrMobile);

	return <Mobile />;
}

export default MainRoutes;
